import { useEffect } from 'react';

import { useAppStore } from '@/modules/app/store/useAppStore';
import { useCanvasOverlay } from '@/modules/canvas/hooks/useCanvasOverlay';

/**
 * Mounted inside the canvas. Renders whatever overlay request is currently
 * published to `useAppStore.canvasOverlayRequest`. Has no knowledge of
 * which feature owns the active request - features push to the store from
 * their own services (`AreaPickerService`, `FlowService`, etc).
 */
export function CanvasOverlayHost() {
  const { show, hide, Overlay } = useCanvasOverlay();
  const request = useAppStore((store) => store.canvasOverlayRequest);

  useEffect(() => {
    if (request === null) {
      hide();
      return;
    }
    show({
      message: request.message,
      onCancel: request.onCancel,
    });
  }, [request, show, hide]);

  return <Overlay />;
}
